module.exports = __webpack_public_path__ + "static/media/logo.f64fcb6e.png";